// colors.ts
export const colors = {
  light: {
    black: {
      full: "#000000",
      light80: "#333333",
      light60: "#666666",
      light40: "#999999",
      light20: "#CCCCCC",
      light10: "#E6E6E6",
      light: "#F7F9FB",
    },
    white: {
      full: "#FFFFFF",
      light80: "#F2F2F2",
      light60: "#CCCCCC",
      light40: "#999999",
      light20: "#7F7F7F",
      light10: "#666666",
      light: "#666666",
    },
    primary: {
      blue: "#2196F3",
      orange: "#FF9800",
      blue50: "#E3F2FD",
      blue25: "#BBDEFB",
      light: "#B3E5FC",
      background: "#EFEFEF",
      blue100: "#5776e7",
      blueviolet100: "#314281",
    },
    greys: {
      50: "#F5F6F7",
      100: "#E2E4E8",
      200: "#C9CCD4",
      300: "#ADB1BC",
      400: "#969BA9",
      500: "#7F8595",
      600: "#565B69",
      700: "#30333A",
      800: "#1D1E23",
      900: "#0A0A0C",
    },
    lightSurface: {
      cloud: "#F6F5EF",
      sand: "#B7B3A4",
      sage: "#AAB199",
      spring: "#C0D2AB",
      mist: "#C1C4CC",
      sky: "#AAB3CB",
    },
    darkSurface: {
      midnight: "#353C52",
      grove: "#2C4748",
    },
    semantic: {
      error: "#9E362C",
      warning: "#E59545",
      success: "#457A4A",
      information: "#326BA8",
    },
  },
  dark: {
    black: {
      full: "#FFFFFF",
      light80: "#CCCCCC",
      light60: "#999999",
      light40: "#666666",
      light20: "#333333",
      light10: "#1A1A1A",
      light: "#F7F9FB",
    },
    white: {
      full: "#000000",
      light80: "#0A0A0A",
      light60: "#1A1A1A",
      light40: "#333333",
      light20: "#4D4D4D",
      light10: "#666666",
      light: "#999999",
    },
    primary: {
      blue: "#2196F3",
      orange: "#FF9800",
      blue50: "#0A1B26",
      blue25: "#142B40",
      light: "#1E3A52",
      background: "#1A1A1A",
      blue100: "#5776e7",
      blueviolet100: "#314281",
    },
    greys: {
      50: "#2E2E2E",
      100: "#3C3C3C",
      200: "#4A4A4A",
      300: "#595959",
      400: "#676767",
      500: "#757575",
      600: "#838383",
      700: "#919191",
      800: "#A0A0A0",
      900: "#AEAEAE",
    },
    lightSurface: {
      cloud: "#2E2E2E",
      sand: "#3C3C3C",
      sage: "#4A4A4A",
      spring: "#5C5C5C",
      mist: "#6E6E6E",
      sky: "#7F7F7F",
    },
    darkSurface: {
      midnight: "#0D1117",
      grove: "#161B22",
    },
    semantic: {
      error: "#FF6B6B",
      warning: "#F4A261",
      success: "#2A9D8F",
      information: "#3296D2",
    },
  },
};

export default colors;
